import React, {
  memo,
  useCallback,
  useEffect,
  useRef
  // useState
} from 'react'

import { Container, makeStyles } from '@material-ui/core'

import ChatMessage from './ChatMessage/ChatMessage'
import { isNumber } from 'lodash'

const useContainerStyle = makeStyles({
  root: {
    minHeight: 250,
    maxHeight: 'calc(60vh - 150px)',
    overflow: 'auto',
    overflowWrap: 'anywhere'
  }
})

const ChatHistory = ({ history, chatKey, onFileClick, onScroll = () => {} }) => {
  const containerClasses = useContainerStyle()
  const containerRef = useRef(null)
  // const [isTopScrolled, setIsTopScrolled] = useState(false)

  const onScrollHandler = useCallback(
    e => {
      onScroll({ ...e })
      // const isTop = e.target.scrollTop === 0
      // if (isTop) {
      //   setIsTopScrolled(true)
      // }
    },
    [onScroll]
  )

  useEffect(() => {
    const containerEl = containerRef.current
    if (containerEl) {
      if (containerEl && history.length) {
        const containerScrollBottom = containerEl.scrollHeight
        // const containerScrollTop = containerEl.scrollTop

        // if (isTopScrolled) {
        containerEl.scrollTo(0, containerScrollBottom)
      }
    }
    // }, [history, isTopScrolled])
  }, [history])

  const messageHistories = history.map(item => {
    const { message, is_owner: isOwner, sender, file, send_at: sendAt } = item
    const key = item[chatKey]

    return (
      <ChatMessage
        key={key}
        isDraft={!isNumber(key)}
        message={message}
        file={file}
        isOwner={isOwner}
        sender={sender}
        timestamp={sendAt}
        onFileClick={() => onFileClick(key)}
      />
    )
  })
  return (
    <Container ref={containerRef} classes={containerClasses} onScroll={onScrollHandler}>
      {messageHistories}
    </Container>
  )
}

export default memo(ChatHistory)
